import { MarketTax, Tax, TaxConfigScope, TaxSemantics } from "models/taxes"

import { http } from "./http"

export const fetchTaxes = async (
  _key: string,
  configScope?: TaxConfigScope,
  configOwnerId?: string,
) => {
  const searchParams = new URLSearchParams()
  !!configScope && searchParams.set("configScope", configScope)
  !!configOwnerId && searchParams.set("configOwnerId", configOwnerId)
  const { data } = await http
    .get(`taxes`, { searchParams })
    .json<{ data: Tax[] }>()
  return data
}

export const createTax = async (pld: Partial<Tax>) => {
  const json = pld
  const res = await http.post("taxes", { json }).json()
  return res as Tax
}

export const patchTax = async (pld: Partial<Tax>): Promise<Tax> => {
  const { id, ...data } = pld
  return (await http.patch(`taxes/${pld.id}`, { json: data })) as any
}

export const deleteTax = async (id: string) => await http.delete(`taxes/${id}`)

export const activateTax = async (id: string) => {
  const res = await http.post(`taxes/${id}/activate`)
  return res
}
export const deactivateTax = async (id: string) => {
  const res = await http.post(`taxes/${id}/deactivate`)
  return res
}

export const fetchSemantics = async (_key: string) => {
  const { data } = await http
    .get("taxes/semantics")
    .json<{ data: TaxSemantics[] }>()
  return data
}

export type AvailableTaxes = {
  AC: Tax[]
  MC: Tax[]
}

export const fetchAvailableTaxes = async (
  _key: string,
  planId: string,
  params: string,
) => {
  const searchParams = new URLSearchParams(params)
  const res = await http
    .get(`media-plans/${planId}/taxes`, { searchParams })
    .json()

  return res as AvailableTaxes
}

export const fetchClientTaxes = async (_key: string, id: string) => {
  const { data } = await http
    .get(`taxes/client/${id}`)
    .json<{ data: MarketTax[] }>()
  return data
}

type TaxActionPld = {
  taxId: string
  clientId?: string
  supplierId?: string
}

export const enableClientTax = async (pld: TaxActionPld) => {
  const { taxId, clientId } = pld
  return await http.post(`taxes/${taxId}/client/${clientId}/enable`)
}

export const disableClientTax = async (pld: TaxActionPld) => {
  const { taxId, clientId } = pld
  return await http.post(`taxes/${taxId}/client/${clientId}/disable`)
}

export const setDefaultClientTax = async (pld: TaxActionPld) => {
  const { taxId, clientId } = pld
  return await http.post(`taxes/${taxId}/client/${clientId}/default`)
}

export const fetchSupplierTaxes = async (_key: string, id: string) => {
  const { data } = await http
    .get(`taxes/supplier/${id}`)
    .json<{ data: MarketTax[] }>()
  return data
}

export const enableSupplierTax = async (pld: TaxActionPld) => {
  const { taxId, supplierId } = pld
  return await http.post(`taxes/${taxId}/supplier/${supplierId}/enable`)
}

export const disableSupplierTax = async (pld: TaxActionPld) => {
  const { taxId, supplierId } = pld
  return await http.post(`taxes/${taxId}/supplier/${supplierId}/disable`)
}

export const setDefaultSupplierTax = async (pld: TaxActionPld) => {
  const { taxId, supplierId } = pld
  return await http.post(`taxes/${taxId}/supplier/${supplierId}/default`)
}
